import { useAuth } from '@/contexts/AuthContext';
import { useSettingsQuery } from '@/hooks/queries/useSettingsQuery';
import { useTechniciansQuery } from '@/features/technicians/hooks/useTechniciansQuery';
import { useTechnicianMutations } from '@/features/technicians/hooks/useTechnicianMutations';
import { useOrdersInfiniteQuery } from '@/features/orders/hooks/useOrdersQuery';

export function useTechniciansDomain() {
    const { isAuthenticated, isLoading: authLoading, user } = useAuth();
    const enabled = isAuthenticated && !authLoading;

    const settingsQuery = useSettingsQuery(enabled);
    const techniciansQuery = useTechniciansQuery(enabled);
    const ordersQuery = useOrdersInfiniteQuery(enabled);

    const authCompanyId = user?.app_metadata?.company_id as string | undefined;
    const computedCompanyId = settingsQuery.data?.id || authCompanyId || '';

    const technicians = techniciansQuery.data ?? [];
    
    // We need orders for the mutations to handle re-assignments
    const technicianMutations = useTechnicianMutations(computedCompanyId, ordersQuery.orders, technicians, user);

    return {
        // Data
        technicians,
        
        // Loading States
        isLoading: techniciansQuery.isLoading,
        isFetching: techniciansQuery.isFetching,
        
        // Error state
        error: techniciansQuery.error,

        // Mutations
        ...technicianMutations
    };
}
